import type * as FirebaseAuth from "firebase/auth"
import type { UserDocument } from "popopo-msg"
import { useForm } from "react-hook-form"
import { api } from "../../core"

type VirtualCastOAuthAPIForms = {
  method: string
  path: string
  query: string
  body: string
}

export const VirtualCastOAuthAPIForm = (props: { firebase: FirebaseAuth.User; user: UserDocument }) => {
  const form = useForm<VirtualCastOAuthAPIForms>({
    mode: "onBlur",
    defaultValues: {
      method: "get",
      path: "/user",
    },
  })

  const onSubmit = async (value: VirtualCastOAuthAPIForms) => {
    try {
      const idToken = await props.firebase.getIdToken()
      const response = await api.POST("/api/v2/users/me/oauth/virtualcast/api-relay", {
        headers: {
          authorization: `Bearer ${idToken}`,
        },
        body: {
          method: value.method,
          path: value.path,
          body: {
            body: value.body,
            query: value.query,
          },
        },
      })
      if (response.data === undefined) {
        console.error(`invalid response: ${JSON.stringify(response.error)}`)
        return
      }
      console.info(response.data)
    } catch (e) {
      console.error(e)
    }
  }

  const { isSubmitting, isValid } = form.formState

  return (
    <>
      <form className="d-flex w-100 flex-column gap-3" onSubmit={form.handleSubmit(onSubmit)}>
        <div className="form-floating">
          <select className="form-control" disabled={isSubmitting} {...form.register("method")}>
            <option value={"get"}>GET</option>
            <option value={"post"}>POST</option>
            <option value={"put"}>PUT</option>
            <option value={"delete"}>DELETE</option>
          </select>
          <label>Method</label>
        </div>

        <div className="form-floating">
          <select className="form-control" disabled={isSubmitting} {...form.register("path")}>
            <option value={"/user"}>/user</option>
            <option value={"/user/items"}>/user/items</option>
            <option value={"unknown"}>unknown</option>
          </select>
          <label>Path</label>
        </div>

        <div className="form-floating">
          <input className="form-control" disabled={isSubmitting} {...form.register("query")} />
          <label>Query</label>
        </div>

        <div className="form-floating">
          <input className="form-control" disabled={isSubmitting} {...form.register("body")} />
          <label>Body</label>
        </div>

        <button type="submit" className="btn btn-primary form-control" disabled={isSubmitting || !isValid}>
          Call OAuth API
        </button>
      </form>
    </>
  )
}
